/**
 * Check if script with specific id already exists in the page
 * @param id
 */
const existTag = (id: string) => !!document.getElementById(id);

/**
 * Initialize external cookies
 * @param analytics - Analytics options of localStorage
 */
const initialize = ({ analytics }) => {
    if (analytics) {
        if (!existTag('googleTagManager')) googleTagManager({ analytics });
        if (!existTag('hotjar')) hotjar({ analytics });
    }
};

const googleTagManager = ({ analytics }) => {
    if (analytics) {
        (function (w, d, s, l, i) {
            // eslint-disable-next-line no-param-reassign
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            var f: any = d.getElementsByTagName(s)[0],
                j: any = d.createElement(s),
                dl = l !== 'dataLayer' ? '&l=' + l : '';
            j.id = 'googleTagManager';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
            if (f.parentNode) f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-KRGCRPR');
    }
};

const hotjar = ({ analytics }) => {
    if (analytics) {
        (function (h, o, t, j, a: any = {}, r: any = {}) {
            // eslint-disable-next-line no-param-reassign
            h['hj'] =
                h['hj'] ||
                function () {
                    // eslint-disable-next-line no-param-reassign
                    (h['hj'].q = h['hj'].q || []).push(arguments);
                };
            // eslint-disable-next-line no-param-reassign
            h['_hjSettings'] = { hjid: 1938183, hjsv: 6 };
            // eslint-disable-next-line no-param-reassign
            a = o.getElementsByTagName('head')[0];
            // eslint-disable-next-line no-param-reassign
            r = o.createElement('script');
            // eslint-disable-next-line no-param-reassign
            r.async = 1;
            // eslint-disable-next-line no-param-reassign
            r.src = t + h['_hjSettings'].hjid + j + h['_hjSettings'].hjsv;
            a.appendChild(r);
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    }
};

export default {
    initialize,
};
